/* eslint-disable @typescript-eslint/no-explicit-any */
import { createRoot } from 'react-dom/client'
import deepmerge from 'deepmerge'
import {
  defaultWidgetConfig,
  EventContainer,
  injectCss,
  IWidgetConfiguration,
  plainConfigValidator,
  WidgetContext,
  widgetFacadeFactory,
  ignoreErrors,
} from '@dxp-module/common'
import { Widget } from './Widget'
import MiniWidgetContainer from './miniWidget/components/containers/MiniWidgetContainer'
import cssReset from './style.css'
import WIDGET_CONFIG_SCHEMA from './configSchema.json'
import MINI_WIDGET_CONFIG_SCHEMA from './miniWidget/constants/miniWidgetConfigSchema.json'

export const widgetLibrary = {
  createWidget: (configuration: IWidgetConfiguration): Promise<any> => {
    return new Promise((resolve: (facade: any) => any) => {
      configuration = deepmerge(defaultWidgetConfig, configuration)

      const eventContainer = new EventContainer()
      const facade = widgetFacadeFactory.create(configuration, eventContainer)

      const jsonValidation =
        plainConfigValidator.validate<IWidgetConfiguration>(
          configuration,
          WIDGET_CONFIG_SCHEMA,
          'myaccount'
        )

      if (jsonValidation !== true) {
        throw jsonValidation
      }

      ignoreErrors.intl()

      const container = document.getElementById(configuration.containerId)
      const root = container && createRoot(container)

      injectCss(cssReset)

      root?.render(
        <div ref={() => resolve(facade)}>
          <WidgetContext.Provider value={[configuration, eventContainer]}>
            <Widget />
          </WidgetContext.Provider>
        </div>
      )
    })
  },

  createMiniWidget: (configuration: IWidgetConfiguration): Promise<any> => {
    return new Promise((resolve: (facade: any) => any) => {
      const isInSalesEnablement =
        window !== top || (window as any).__CYPRESS_IS_IN_IFRAME

      if (isInSalesEnablement) {
        return resolve(null)
      }

      configuration = deepmerge(defaultWidgetConfig, configuration)

      const eventContainer = new EventContainer()
      const facade = widgetFacadeFactory.create(configuration, eventContainer)

      const jsonValidation =
        plainConfigValidator.validate<IWidgetConfiguration>(
          configuration,
          MINI_WIDGET_CONFIG_SCHEMA,
          'myaccount'
        )

      if (jsonValidation !== true) {
        throw jsonValidation
      }

      ignoreErrors.intl()

      const container = document.getElementById(configuration.containerId)
      const root = container && createRoot(container)

      injectCss(cssReset)

      root?.render(
        <div ref={() => resolve(facade)}>
          <WidgetContext.Provider value={[configuration, eventContainer]}>
            <MiniWidgetContainer />
          </WidgetContext.Provider>
        </div>
      )
    })
  },
}

export const DXPWidget = Object.freeze(widgetLibrary)
;(window as any).DXPMyAccount = DXPWidget
